import { gql } from 'apollo-boost';

export const donors = gql`
query {
  donors {
    id
    name
  }
}
`;
